
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from '../../../../config/config';
import { ClientApiValidation } from "../../views/ClientApi/Validation/ClientApiValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors, redirectCallback, redirectRoleList) => {

  event.preventDefault();
  const formErrors = ClientApiValidation(formData);
  setErrors(formErrors);
  if (Object.keys(formErrors).length === 0) {
    try {

      const token = localStorage.getItem('token');
      if (!token || token == "null") {
        redirectCallback();
        return; // Return early to prevent further execution
      }

      const CompanyID = localStorage.getItem("CompanyID");
      //formData.ClientID = CompanyID;

      const response = await axiosInstance.post(`/Setup/CreateClientApi`, formData);
      return response.data;

      
    } catch (error) {
      console.error('Error posting data:', error);
    }
  }
};

export { handleChange, handleSubmit };